module.exports = __webpack_public_path__ + "static/media/icon-kid-walk-orange.a7bd32ce.svg";